import { render } from "./Index.vue?vue&type=template&id=5c6694b9&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=5c6694b9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c6694b9"

export default script